export const testIdUnitToggleDollarPerTon = 'test-id_unit-toggle_dollars-per-ton';
export const testIdUnitToggleCentPerPound = 'test-id_unit-toggle_cents-per-pound';
